import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  GoToTopContainer,
  GoToTopFab,
  GoToTopFabContainer,
} from "./GoToTop.style";

interface GoToTopProps {
  onClick: () => void;
}

const GoToTop = ({ onClick }: GoToTopProps) => {
  return (
    <GoToTopContainer>
      <GoToTopFabContainer>
        <GoToTopFab aria-label="scroll to top" size="medium" onClick={onClick}>
          <ExpandLessIcon color="disabled" />
        </GoToTopFab>
      </GoToTopFabContainer>
    </GoToTopContainer>
  );
};

export default GoToTop;
